<template>
  <div class="ds-sheet">
    <header class="ds-letterhead">
      <div class="ds-brand">
        <img v-if="logoUrl" :src="logoUrl" class="ds-logo" alt="">
        <div v-else class="ds-brand-name">{{ letterhead.name }}</div>
      </div>
      <div class="ds-company">
        <div class="ds-company-name">{{ letterhead.name }}</div>
        <div v-if="letterhead.url">{{ letterhead.url }}</div>
        <div v-if="letterhead.tel">Tel. {{ letterhead.tel }}</div>
      </div>
    </header>
    <section class="ds-intro">
      <div class="ds-eyebrow">Zahlung</div>
      <div class="ds-title">Quittung</div>
    </section>
    <section class="ds-kpis">
      <div class="ds-kpi">
        <span>Fahrer</span>
        <strong>{{ driverName || '–' }}</strong>
      </div>
      <div class="ds-kpi ds-kpi-main">
        <span>Betrag</span>
        <strong>{{ euro(payment.amount) }}</strong>
      </div>
    </section>
    <table class="ds-fields">
      <tbody>
        <tr>
          <th scope="row">Zahlungs-ID</th>
          <td>{{ payment.id }}</td>
        </tr>
        <tr>
          <th scope="row">Zahlungsdatum</th>
          <td>{{ payDate }}</td>
        </tr>
        <tr v-if="billingText">
          <th scope="row">Abrechnungsmonat</th>
          <td>{{ billingText }}</td>
        </tr>
        <tr v-if="payment.pay_place">
          <th scope="row">Bezahlt wo</th>
          <td>{{ payment.pay_place }}</td>
        </tr>
        <tr v-if="payment.comment">
          <th scope="row">Bemerkung</th>
          <td>{{ payment.comment }}</td>
        </tr>
        <tr>
          <th scope="row">Erstellt am</th>
          <td>{{ createdAt }}</td>
        </tr>
      </tbody>
    </table>
    <div class="ds-sign">
      <div>Datum, Unterschrift Fahrer</div>
      <div>Datum, Unterschrift Empfänger</div>
    </div>
    <footer class="ds-footer">
      <span>Gute Fahrt wünscht</span>
      <img :src="simaLogoUrl" class="ds-sima-logo" alt="SIMA">
      <span>www.simasoftware.de</span>
    </footer>
  </div>
</template>

<script>
// Druckblatt „Quittung“ einer Zahlung (Kundenwunsch 13.10.2026: Ausdruck der Zahlungen wie bei den Verkäufen – Inhalt
// wie die frühere Word-Vorlage PaymentReceiptTemplate.docx, Kopf, Fuß und Erzeugung im Browser wie die
// Fahrerabrechnung). Inhalt aus den Daten, die bisher an die Vorlage gingen: Fahrer, Betrag, Zahlungs-ID,
// Zahlungsdatum, Abrechnungsmonat, Zahlungsort, Bemerkung und Erstelldatum, dazu Unterschriftszeilen. Nur Markup mit den
// Klassen .ds-* (src/utils/printSheet.js); Payment.vue rendert es unsichtbar und druckt sein HTML.
// Props: payment (Zeile der Zahlung), driverName, letterhead { name, url, tel }, logoUrl, simaLogoUrl, createdAt.
import moment from "moment";

const euroFormat = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });

export default {
  name: "PaymentReceiptSheet",
  props: {
    payment: { type: Object, required: true },
    driverName: { type: String, default: "" },
    letterhead: { type: Object, required: true },
    logoUrl: { type: String, default: null },
    simaLogoUrl: { type: String, required: true },
    createdAt: { type: String, default: "" }
  },
  computed: {
    payDate() {
      return this.payment.pay_date ? moment(this.payment.pay_date).format("DD.MM.YYYY") : "–";
    },
    billingText() {
      const month = Number(this.payment.billing_month);
      const year = Number(this.payment.billing_year);
      return month && year ? moment({ year, month: month - 1, day: 1 }).format("MMMM YYYY") : "";
    }
  },
  methods: {
    euro(value) {
      return euroFormat.format(Number(value) || 0);
    }
  }
};
</script>
